import * as React from 'react';
import { connect } from 'react-redux';
import RegisterUser from '../RegisterUser/RegisterUser';
import WhyChooseKP from '../SignUp/WhyChooseKP';
import SignInSignUpSharedFooter from '../SignIn/SignInSignUpSharedFooter';

class RegisterPage extends React.Component<any, any> {

    public render() {

        let signup = <>
            <h2 className="log-in-text">Sign up</h2>
            <RegisterUser />
        </>

        return (
             <>
                <div id="RegisterPage" className="pt-5 pb-5 row mx-auto">
                    <div className="text-center pt-5 log-in-div mx-auto ml-lg-auto mr-lg-3" >
                        {signup}
                    </div>
                    <div className="float-right pt-3 mx-auto mr-lg-auto ml-lg-3">
                        <WhyChooseKP />
                    </div>
                </div>
                <SignInSignUpSharedFooter />
            </>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        auth: state.firebase.auth,
        profile: state.profile
    }
}

export default connect(mapStateToProps)(RegisterPage);